module.exports = __webpack_public_path__ + "static/lean-in-5898a6a0d5b367baac89925b324f6f93.jpg";